import { render } from "./WinsStacker.vue?vue&type=template&id=70a0e06e&scoped=true"
import script from "./WinsStacker.vue?vue&type=script&lang=js"
export * from "./WinsStacker.vue?vue&type=script&lang=js"

import "./WinsStacker.vue?vue&type=style&index=0&id=70a0e06e&lang=scss&scoped=true"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a0e06e"]])

export default __exports__